import { useStaticQuery, graphql } from "gatsby"

export const useAudiobooksImages = () => {
  const data = useStaticQuery(graphql`
    query {
      dofkult: file(relativePath: { eq: "img/audiobooks/dofkult.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _001_small: file(
        relativePath: { eq: "img/audiobooks/small001-min.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      _002_small: file(
        relativePath: { eq: "img/audiobooks/small002-min.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      _003_small: file(
        relativePath: { eq: "img/audiobooks/small003-min.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 800, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
    }
  `)
  return data
}
